<template>
  <div class="view pa24">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <h3>1.{{ $t('finance', 'commissionSettlementCycle') }}</h3>
      </div>
      <div>
        {{ $t('finance', 'orderCompletedDays') }}
        <el-input style="width: 70px" v-model="settlementDate" />
        {{ $t('finance', 'days') }}
      </div>
    </el-card>
    <el-card class="box-card mt20" shadow="never">
      <div slot="header" class="clearfix">
        <h3>2.{{ $t('finance', 'commissionWithdrawalLimit') }}</h3>
      </div>
      <div class="mb10">
        {{ $t('finance', 'withdrawalAmountLimit') }}
        <el-input-number style="width: 100px"
                         v-model="num" 
                         controls-position="right"  
                         :min="1"
                         ></el-input-number>
        {{ $t('finance', 'yuan') }}，{{ $t('finance', 'withdrawal') }}
      </div>
    </el-card>
    <div class="mt20" style="text-align:center">
      <el-button  type="primary" plain @click="saveSetting">{{ $t('finance', 'save') }}</el-button>
      <p class="mt10">{{ $t('finance', 'saveTip') }}</p>
      <div v-if="!hasData" class="mt10" style="color: #f56c6c; font-size: 14px;">
        <i class="el-icon-warning"></i>
        {{ $t('finance', 'pleaseConfigureCommissionSettings') }}
      </div>
    </div>
  </div>
</template>

<script>
import { updateSetting ,querySetting} from "@/api/financing";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "commissionSettings",
  mixins: [i18nMixin],
  data() {
    return {
      switchValue: null,
      num: null,
      settlementDate: null,
      hasData: false // 标记是否有数据
    };
  },
  created(){
    this.getSetting()
  },
  methods:{
    getSetting(){
        let data =  {
          xx: 'x',
        }
      querySetting(data)
      .then(res => {
        if(res.data){
          this.switchValue = res.data.autoArrive;
          this.settlementDate = res.data.settlementDate;
          this.num = res.data.cashAmount;
          this.hasData = true;
        } else {
          // 如果没有数据，保持空值
          this.switchValue = null;
          this.settlementDate = null;
          this.num = null;
          this.hasData = false;
        }
      }).catch(function (err) {
        // 请求失败时也保持空值
        this.switchValue = null;
        this.settlementDate = null;
        this.num = null;
        this.hasData = false;
      });
    },
    saveSetting(){
      let data = {
        autoArrive : this.switchValue,
        settlementDate : this.settlementDate,
        cashAmount: this.num,
      }
      updateSetting(data)
      .then(res=>{
        if(res.code == 200){
          this.hasData = true; // 保存成功后标记为已设置
          this.$message({
            message: this.$t('finance', 'save') + this.$t('finance', 'success'),
            type: "success",
          });
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>